import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap';
import { destroyPartner } from "../../actions/partnerActions";
const PartnerDashbord = (props) => {
    const dispatch =  useDispatch();
    const [deleteProfileModal, setDeleteProfileModal] = useState(false)
    const [partnerData, setData] = useState();

    const deleteProfileModalShow = partnerData => {
        const data = {
            partner_id: partnerData.partner_id,
            project_id: partnerData.project_id
        }
        setData(data)
        setDeleteProfileModal(true)
    }

    const deleteProfileModalClose = () => {
        setDeleteProfileModal(false)
        setData()
    }
    const handleDeletePartnereSubmit = () => {
        dispatch(destroyPartner(partnerData))
        setDeleteProfileModal(false)
        setData()
    }
    return (
        <>
            <div className="col-lg-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">My Partners ({props.partners?.length})</h2>
                        {/* <Link to='/invite-partner' className="dropdown-animated scale-left text-white"><i className="fa fa-plus-circle mr-2"></i>New Client</Link> */}
                    </div>
                    <div className="body text-center card-body-shadow">
                        <div className="row clearfix">
                            { props.partners && props.partners.slice(0, 3).map((partner, index) => (
                            <div key={index} className="col-lg-4 col-md-8 col-sm-12 mt-3">
                                <div className="icon-menu">
                                    <div className="card p-3 rounded-xl">
                                        <img className="rounded-circle" width={'76px'} height={'76px'} alt={partner.name} src={partner?.profile_pic_url} />
                                        <div>
                                       <Link to={'/partners'} className="mt-2 btn button">View scope</Link>
                                        </div>
                                    </div>
                                    <span className="delete-icon" variant="outlined" size="small" color="dark" title='Delete User' data-toggle="modal" data-target="#exampleModalLong" onClick={() => deleteProfileModalShow(partner)}>
                                        <i className='icon-close'></i>
                                    </span>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                       <Modal show={deleteProfileModal} onHide={deleteProfileModalClose} >
                            <div className="modal-dialog  m-0" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title text-danger">Delete Partner From Server</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={deleteProfileModalClose}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        Are you sure to delete?
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleDeletePartnereSubmit}>Confirm</button>
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={deleteProfileModalClose}>Close</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                               
                </div>
            </div>
        </>
    );
}
export default PartnerDashbord;